import { useTranslation } from "react-i18next";

import { cn } from "~/components/ui/cn";
import { RefundIcon } from "~/components/ui/icons/refund";
import { OrderTagRefund } from "~/graphql/graphql-new.gen";

import { OrderBadge } from "../order-status-badge/order-badge";
import { getOrderRefundLabelFromTag } from "../order-status-badge/order-refund-badge";

export const OrderRefundBadge: React.FC<{
  isCancelled?: boolean;
  tag: OrderTagRefund;
}> = ({ isCancelled, tag }) => {
  const { t } = useTranslation();

  if (tag === OrderTagRefund.None) return null;

  return (
    <OrderBadge variant="filled" intent="bold">
      <div className="flex items-center gap-x-1">
        <RefundIcon className="!size-3.5" />
        <span className={cn({ "line-through": isCancelled })}>
          {getOrderRefundLabelFromTag(tag, t)}
        </span>
      </div>
    </OrderBadge>
  );
};
